import classnames from 'classnames'

import PropTypes from 'prop-types'
import { requiredIf } from '../../../../utility/prop-types-helper'
import GenderBreakdownPie from '../../../common/GenderBreakdownPie/GenderBreakdownPie'
import Loader from '../../../common/loader/Loader'

import classes from './StatsPanel.module.scss'

const StudentInformationWidget = ({ isLoading, studentsInfo }) => {
  const withStudents = studentsInfo?.totalStudents > 0

  if (isLoading) {
    return (
      <section className={classnames('mt-3 d-flex align-items-center justify-content-center', classes.infoSection)}>
        <Loader>Loading Business Summary</Loader>
      </section>
    )
  }

  return (
    <section className={classnames('mt-3 p-3 d-flex flex-column', classes.infoSection)}>
      <h3 className={classnames('mb-3', classes.title)}>Student Information</h3>
      <span className={classes.subtitle}>Age Range</span>
      <span className={classes.title}>
        {withStudents ? `${studentsInfo?.minimumAge} to ${studentsInfo?.maximumAge} year olds` : '----'}
      </span>
      <div className='flex-grow-1 flex-shrink-0 min-h-0'>
        <GenderBreakdownPie
          male={studentsInfo?.maleStudents}
          female={studentsInfo?.femaleStudents}
          other={studentsInfo?.otherStudents}
        />
      </div>
      <div className={classnames('my-3 d-flex justify-content-between', classes.statsItem)}>
        <span>Average Age</span>
        <span>
          {withStudents ? studentsInfo?.averageAge : '---'}
        </span>
      </div>
      <div className={classnames('mb-3 d-flex justify-content-between', classes.statsItem)}>
        <span>Skill Level Range</span>
        <span>
          {withStudents ? `L${studentsInfo?.minimumDivisionLevel} - L${studentsInfo?.maximumDivisionLevel}` : '---'}
        </span>
      </div>
    </section>
  )
}

StudentInformationWidget.propTypes = {
  isLoading: PropTypes.bool,
  studentsInfo: requiredIf(PropTypes.object, ({ isLoading }) => !isLoading),
}

export default StudentInformationWidget
